import { render, staticRenderFns } from "./MobileFlights.vue?vue&type=template&id=61c0e92f&"
import script from "./MobileFlights.vue?vue&type=script&lang=js&"
export * from "./MobileFlights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports